import { CharacterAttack } from './CharacterAttack';

export class CharacterAttackThrow extends CharacterAttack {
  trigger() {
    // this._direction = this._character.faceDirection;
    super.trigger();
  }

  updateActive(delta) {
    // const viewport = this.scene.viewport;
    // this._character.setX(this._character.x + 750 * delta * this._direction);
    // const bounds = this.character.getBounds();
    // this.character.attackCollider.setDisplaySize(bounds.width, bounds.height);
    // this.character.attackCollider.x = bounds.centerX;
    // this.character.attackCollider.y = bounds.centerY;
    // if (this.character.x <= viewport.x || this._character.x > viewport.x + viewport.width) {
    //   this.complete();
    // }
  }
}
